import { render } from "./TungstenFabricPolicyTag.vue?vue&type=template&id=143e7517"
import script from "./TungstenFabricPolicyTag.vue?vue&type=script&lang=js"
export * from "./TungstenFabricPolicyTag.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__